<template>
  <multiselect
    :options="products"
    :searchable="true"
    :internal-search="false"
    :loading="isSearching"
    :options-limit="50"
    :reset-after="false"
    :show-labels="false"
    :multiple="true"
    v-model="selectedProduct"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε προϊόν..."
    select-label="Πατήστε enter για επιλογή"
    @search-change="searchProducts"
    @select="selectProduct"
    @remove="handleRemove"
  >
    <template v-slot:option="props" class="option">
      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import debounce from 'lodash/debounce';
import request from '@/utils/request';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
  },
  props: {
    product: Array,
  },
  data() {
    return {
      products: [],
      isSearching: false,
    };
  },
  computed: {
    selectedProduct: {
      get() {
        return this.product;
      },
      set(value) {
        return value;
      },
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    searchProducts: debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/products-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.products = data.products;
      }
    }, 300),
    selectProduct(selectedOption) {
      this.$emit('select-product', selectedOption);
    },
    handleRemove(selectedOption) {
      this.$emit('remove-product', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;
}
</style>
